<template>
  <div class="song-cover" :style="{ width: size + 'px', height: size + 'px' }">
    <img
      v-if="coverUrl && !hasError"
      :src="coverUrl"
      :alt="alt"
      class="song-cover-image"
      @error="handleError"
    />
    <img
      v-else
      :src="defaultCover"
      :alt="alt"
      class="song-cover-image"
    />
  </div>
</template>

<script>
import defaultCover from '@/images/default-cover.svg'

export default {
  name: 'SongCover',

  props: {
    coverUrl: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: 'Album cover'
    },
    size: {
      type: Number,
      default: 40
    }
  },

  data () {
    return {
      defaultCover,
      hasError: false
    }
  },

  watch: {
    coverUrl () {
      this.hasError = false
    }
  },

  methods: {
    handleError () {
      this.hasError = true
    }
  }
}
</script>

<style scoped>
.song-cover {
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  background-color: #333;
}
.song-cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SongCover.vue